import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { HookSection } from './HookSection';
import { OfferSection } from './OfferSection';
import { PriceSection } from './PriceSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { RecentPurchaseToast } from './RecentPurchaseToast';
import { XIcon } from 'lucide-react';
export function SalesPage() {
  const [modal, setModal] = useState<'terms' | 'privacy' | null>(null);
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    ;
    (window as any).fbq('init', '1609417253435117');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-cream font-sans text-brown-primary selection:bg-rose-gold/30 relative" data-id="element-171">
      {/* Navigation / Header Placeholder */}
      <nav className="w-full py-4 px-6 flex justify-center border-b border-brown-secondary/10 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-172">
        <span className="font-serif text-xl font-bold tracking-wider text-brown-primary" data-id="element-173">
          PIEL DE VIDRIO
        </span>
      </nav>

      <HeroSection data-id="element-174" />
      <HookSection data-id="element-175" />
      <OfferSection data-id="element-176" />
      <PriceSection data-id="element-177" />
      <GuaranteeSection data-id="element-178" />
      <FAQSection data-id="element-179" />
      <FinalCTA data-id="element-180" />

      {/* Social Proof Toast */}
      <RecentPurchaseToast data-id="element-181" />

      {/* Footer */}
      <footer className="bg-brown-primary text-cream/60 py-8 px-4 text-center text-sm" data-id="element-182">
        <div className="flex justify-center gap-6 mb-3" data-id="element-183">
          <button onClick={() => setModal('terms')} className="hover:text-cream transition-colors underline-offset-2 hover:underline" data-id="element-184">
            Términos y Condiciones
          </button>
          <button onClick={() => setModal('privacy')} className="hover:text-cream transition-colors underline-offset-2 hover:underline" data-id="element-185">
            Política de Privacidad
          </button>
        </div>
        <p data-id="element-186">&copy; 2026 Piel de Vidrio. Todos los derechos reservados.</p>
      </footer>

      {/* Modal */}
      {modal && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4" onClick={() => setModal(null)} data-id="element-187">
          <div className="bg-cream rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-188">
            <div className="sticky top-0 bg-cream border-b border-brown-secondary/10 flex items-center justify-between px-6 py-4 rounded-t-xl z-10" data-id="element-189">
              <h3 className="font-serif text-xl font-bold text-brown-primary" data-id="element-190">
                {modal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h3>
              <button onClick={() => setModal(null)} className="p-1 rounded-full hover:bg-brown-secondary/10 transition-colors" data-id="element-191">
                <XIcon className="w-5 h-5 text-brown-secondary" data-id="element-192" />
              </button>
            </div>

            <div className="px-6 py-6 text-brown-secondary leading-relaxed space-y-4 text-sm" data-id="element-193">
              {modal === 'terms' ? <>
                  <p data-id="element-194">
                    <strong className="text-brown-primary" data-id="element-195">
                      1. Aceptación de los Términos
                    </strong>
                    <br data-id="element-196" />
                    Al adquirir y descargar la guía "Piel de Vidrio: Lujo de
                    Farmacia", aceptas estos términos y condiciones en su
                    totalidad.
                  </p>
                  <p data-id="element-197">
                    <strong className="text-brown-primary" data-id="element-198">
                      2. Producto Digital
                    </strong>
                    <br data-id="element-199" />
                    Este producto es una guía digital en formato PDF. Una vez
                    realizada la compra, recibirás acceso inmediato a la
                    descarga. Debido a la naturaleza digital del producto, no se
                    aceptan devoluciones.
                  </p>
                  <p data-id="element-200">
                    <strong className="text-brown-primary" data-id="element-201">
                      3. Uso Personal
                    </strong>
                    <br data-id="element-202" />
                    La guía es para uso personal y exclusivo del comprador.
                    Queda prohibida su reproducción, distribución o reventa sin
                    autorización expresa.
                  </p>
                  <p data-id="element-203">
                    <strong className="text-brown-primary" data-id="element-204">
                      4. Resultados
                    </strong>
                    <br data-id="element-205" />
                    Los resultados pueden variar según el tipo de piel y la
                    constancia en la aplicación del método. La guía no sustituye
                    el consejo de un dermatólogo profesional.
                  </p>
                  <p data-id="element-206">
                    <strong className="text-brown-primary" data-id="element-207">
                      5. Propiedad Intelectual
                    </strong>
                    <br data-id="element-208" />
                    Todo el contenido de la guía está protegido por derechos de
                    autor © 2026 Piel de Vidrio.
                  </p>
                </> : <>
                  <p data-id="element-209">
                    <strong className="text-brown-primary" data-id="element-210">
                      1. Información que Recopilamos
                    </strong>
                    <br data-id="element-211" />
                    Recopilamos únicamente la información necesaria para
                    procesar tu compra: nombre y correo electrónico.
                  </p>
                  <p data-id="element-212">
                    <strong className="text-brown-primary" data-id="element-213">
                      2. Uso de la Información
                    </strong>
                    <br data-id="element-214" />
                    Tu información se utiliza exclusivamente para entregar el
                    producto digital y enviarte actualizaciones relacionadas con
                    tu compra.
                  </p>
                  <p data-id="element-215">
                    <strong className="text-brown-primary" data-id="element-216">
                      3. Protección de Datos
                    </strong>
                    <br data-id="element-217" />
                    No compartimos, vendemos ni cedemos tu información personal
                    a terceros bajo ninguna circunstancia.
                  </p>
                  <p data-id="element-218">
                    <strong className="text-brown-primary" data-id="element-219">4. Cookies</strong>
                    <br data-id="element-220" />
                    Nuestro sitio puede utilizar cookies para mejorar tu
                    experiencia de navegación. Puedes desactivarlas en la
                    configuración de tu navegador.
                  </p>
                  <p data-id="element-221">
                    <strong className="text-brown-primary" data-id="element-222">5. Contacto</strong>
                    <br data-id="element-223" />
                    Para cualquier consulta sobre tu privacidad, puedes
                    comunicarte con nosotros a través de nuestros canales
                    oficiales.
                  </p>
                </>}
            </div>
          </div>
        </div>}
    </main>;
}